import { CredentialsID } from '@playq/octopus2-auth';
import { CommonSuccess, GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

import { removeCredentialMutationKeys } from './constants';

export const useDeleteCredentials = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, CredentialsID>
) =>
  useEitherMutation((id: CredentialsID) => services2.adminCredentialsManagementService.delete(id), {
    mutationKey: removeCredentialMutationKeys,
    ...options,
  });
